import { useEffect, useState } from "react";
import axios from "utils/axios";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@pankod/refine-mui";
import { toast } from "react-toastify";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import SimpleUploadZone from "../../components/SimpleUploadZone";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useFieldArray } from "@pankod/refine-react-hook-form";
import { useSelect } from "@pankod/refine-core";

export default function CompFields({
  register,
  errors,
  control,
  getValues,
  setValue,
  record,
  adv,
  productsData,
}) {
  const [offerFile, setOfferFile] = useState();

  const { options: all_products } = useSelect({
    resource: "products",
    optionLabel: "name",
    optionValue: "id",
  });

  useEffect(() => {
    if (record && record.file) setOfferFile(record.file);
  }, [record]);

  useEffect(() => {
    setValue("advertisement", Number(localStorage.getItem("ad")));
  }, [setValue]);

  // base fields
  const fields = [
    {
      label: "Risposta",
      name: "seller_reply",
      required: true,
      type: "text",
      md: 12,
      style: { marginBottom: "20px" },
    },
  ];

  const {
    fields: product_fields,
    append,
    remove,
    update,
  } = useFieldArray({
    control,
    name: "products",
  });

  const removeDocument = async (docId) => {
    try {
      await axios.delete(`/api/upload/files/${docId}`);

      setOfferFile(null);
      setValue("file", null);
      toast.success("documento eliminato");
    } catch (error) {
      toast.error("Si è verificato un errore");
    }
  };

  const data = adv?.description || "";

  if (!adv) return null;

  return (
    <Grid container spacing={3} sx={{ maxWidth: "1200px" }}>
      <Grid item xs={12}>
        <Grid container spacing={2} style={{ padding: "30px" }}>
          <Stack direction="column" gap={2} sx={{ padding: "20px" }}>
            <Typography variant="h4">OFFERTA per: {adv?.title} </Typography>
            <Typography variant="h5">
              Richiesta da: {adv?.owner?.business_name}{" "}
            </Typography>
            <Typography variant="body1">
              <h3>Descrizione:</h3>
              <span
                dangerouslySetInnerHTML={{
                  __html: data.replace(/\n/g, "<br />"),
                }}
              />
            </Typography>
            <Grid container spacing={2} style={{ padding: "30px" }}>
              <Box variant="body1" ml={1} mt={4}>
                <Stack direction="row" gap={8}>
                  <Stack direction="column" gap={1}>
                    <div>
                      <strong>Data pubblicazione:</strong>
                    </div>
                    <div>{adv.publication_date}</div>
                  </Stack>
                  <Stack direction="column" gap={1}>
                    <div>
                      <strong>Data scadenza:</strong>
                    </div>
                    <div>{adv.expiry_date}</div>
                  </Stack>
                  <Stack direction="column" gap={1}>
                    <div>
                      <strong>Comune:</strong>
                    </div>
                    <div>{adv.municipality?.name || "MANCA DATO"}</div>
                  </Stack>
                </Stack>
              </Box>
            </Grid>
            {fields.map((field, index) => {
              return (
                <AutoGeneratedInputCmp
                  key={index}
                  {...field}
                  register={register}
                  control={control}
                  errors={errors}
                  getValues={getValues}
                  setValue={setValue}
                />
              );
            })}
          </Stack>
        </Grid>
        <Grid
          container
          spacing={2}
          direction="column"
          style={{ padding: "40px" }}
          justifyContent="center"
          gap={2}
          alignItems="start"
        >
          <Typography variant="h6">PRODOTTI</Typography>
          <Grid gap={1} container>
            {product_fields?.map((product, index) => {
              const { id } = product;
              let productSelected = productsData.find(
                (x) => x.id === product.product
              );
              const productFromFields = getValues(`products.${index}.product`);
              // console.log(productFromFields);
              productSelected = productsData.find(
                (x) => x.id === productFromFields
              );
              // console.log(productSelected);

              return (
                <Grid item xs={12} container key={id} gap={2} mb={2}>
                  <Grid item xs={5}>
                    <TextField
                      {...register(`products.${index}.product`, {
                        required: true,
                      })}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant={"outlined"}
                      fullWidth
                      label="Prodotto"
                      select
                      defaultValue={""}
                      onChange={(e) => {
                        const productSelect = all_products.find(
                          (p) => p.value === e.target.value
                        );
                        const prod = productsData.find(
                          (p) => p.id === e.target.value
                        );

                        if (prod) {
                          update(index, {
                            ...product,
                            label: productSelect.label,
                            product: productSelect.value,
                            category: prod.product_category?.name || "N.D",
                            unit_type: prod.unit_type || "N.D",
                            unnit_size: prod.unit_size || "N.D",
                          });
                        }
                      }}
                      value={product.product}
                    >
                      {all_products.map((option, index) => (
                        <MenuItem key={index} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={2}>
                    <TextField
                      type="number"
                      inputProps={{ min: 0 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            &euro;
                          </InputAdornment>
                        ),
                      }}
                      label="Prezzo"
                      color="primary"
                      {...register(`products.${index}.price`, {
                        required: true,
                      })}
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <TextField
                      type="number"
                      inputProps={{ min: 0 }}
                      label="Quantità"
                      color="primary"
                      {...register(`products.${index}.quantity`, {
                        required: true,
                      })}
                    />
                  </Grid>

                  <Grid item xs={1}>
                    <DeleteForeverIcon
                      onClick={() => remove(index)}
                      fontSize="large"
                      color="action"
                      style={{ marginTop: "8px", cursor: "pointer" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {productSelected && (
                      <TextField
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant={"outlined"}
                        fullWidth
                        label="Prodotto"
                        select
                        value={getValues(`products.${index}.packaging`)}
                        onChange={(e) => {
                          const packageSelected =
                            productSelected.packagings.find(
                              (p) => p.id === e.target.value
                            );
                          update(index, {
                            ...product,
                            label: productSelected.name,
                            product: productSelected.id,
                            packaging: packageSelected.id,
                            category:
                              productSelected.product_category?.name || "N.D",
                            unit_type: packageSelected.unit_type || "N.D",
                            unit_size: packageSelected.unit_size || "N.D",
                          });
                          console.log(getValues("products"));
                        }}
                      >
                        {(productSelected.packagings || []).map(
                          (option, index) => (
                            <MenuItem key={index} value={option.id}>
                              {option?.quantity} confezioni da{" "}
                              {option?.unit_size} {option?.unit_type}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    )}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
          <Button
            startIcon={<AddCircleIcon />}
            variant="outlined"
            color="primary"
            onClick={() => {
              append({ product: "", price: 0, quantity: 0 });
            }}
          >
            Aggiungi Prodotto
          </Button>
          <Typography variant="h6" marginTop={4}>
            PREVENTIVO
          </Typography>
          {offerFile ? (
            <Stack direction="row" alignItems="center" gap={2} marginLeft={2}>
              {offerFile?.mime.includes("image") ? (
                <ImageIcon />
              ) : (
                <DescriptionIcon />
              )}
              {offerFile.name}
              <DeleteForeverIcon
                onClick={() => removeDocument(offerFile.id)}
                sx={{ color: "red", cursor: "pointer" }}
              />
            </Stack>
          ) : (
            <SimpleUploadZone
              label="CARICA DOCUMENTO"
              onChange={async (file) => {
                console.log(file);
                try {
                  setValue("file", file.id);
                  setOfferFile(file);

                  toast.success("Documento caricato con successo");
                } catch (error) {
                  toast.error("Documento non caricato");
                  console.log(error);
                }
              }}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
